/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planning_Rooster_Geen_KlasInputs */

const nl_planning_rooster_geen_klas = /** @type {(inputs: Planning_Rooster_Geen_KlasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen klas gevonden`)
};

/**

* @param {Planning_Rooster_Geen_KlasInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const planning_rooster_geen_klas = /** @type {((inputs?: Planning_Rooster_Geen_KlasInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planning_Rooster_Geen_KlasInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_planning_rooster_geen_klas(inputs)
});
export { planning_rooster_geen_klas as "planning.rooster.geen_klas" }